import HTTP from '../common/http-common';

const END_POINT = '/employee';

const listPositions = () => HTTP.get(END_POINT + "/positions");
const listEmployee = () => HTTP.get(END_POINT, { cache: false });
const listEmployeeBybranch = (branchCode) => HTTP.get(END_POINT + "/branch/" + branchCode, { cache: false });
const isExistEmployeeCode = (branchCode, empCode, empId) => HTTP.get(END_POINT +  "/empCode/" + branchCode + "/" + empCode + "/" + empId, { cache: false });
const insert = (data) => HTTP.post(END_POINT, {
    empCode: data.empCode,
    gender: data.gender,
    firstName: data.firstName,
    lastName: data.lastName,
    phone: data.phone,
    branchCode: data.branchCode,
    positionCode: data.positionCode,
    wagePerMin: data.wagePerMin,
    email: data.email
});
const update = (data) => HTTP.post(END_POINT + "/" + data.empId, {
    empCode: data.empCode,
    gender: data.gender,
    firstName: data.firstName,
    lastName: data.lastName,
    phone: data.phone,
    branchCode: data.branchCode,
    positionCode: data.positionCode,
    wagePerMin: data.wagePerMin,
    email: data.email
});

const deleteEmployee = (empId) => HTTP.delete(END_POINT + "/" + empId);

export {
    listPositions,
    listEmployee,
    isExistEmployeeCode,
    insert,
    update,
    deleteEmployee,
    listEmployeeBybranch
}